"use client";
import { jsxs as a, jsx as o } from "react/jsx-runtime";
import l from "clsx";
import { memo as g, useMemo as N } from "react";
import { Box as _ } from "../../blocks/base/Base.js";
import { s as e } from "../../Input.module-DvgZOYt7.js";
const b = g(
  ({
    name: s,
    center: m,
    placeholder: n,
    value: r,
    maxLength: t = 300,
    className: i,
    loading: c,
    disabled: p,
    error: x,
    size: d = "normal",
    ...h
  }) => {
    const f = N(() => String(r).length || 0, [r]);
    return /* @__PURE__ */ a(_, { gap: 12, children: [
      s && /* @__PURE__ */ o("span", { className: l(e.name, { [e._center]: m }), children: s }),
      /* @__PURE__ */ a("label", { className: e.label, children: [
        /* @__PURE__ */ o(
          "textarea",
          {
            className: l(
              e.input,
              e.textarea,
              e[d],
              {
                [e._loading]: c,
                [e._error]: x,
                [e._disabled]: p
              },
              i
            ),
            placeholder: n,
            value: r,
            rows: 5,
            maxLength: t,
            ...h
          }
        ),
        /* @__PURE__ */ a("span", { className: e.textarea_lenght, children: [
          f,
          " / ",
          t
        ] })
      ] })
    ] });
  }
);
b.displayName = "Textarea";
export {
  b as Textarea
};
